import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { PortalDoVendedorUtilsBaseApiModule } from '../../base-api';
import { PortalDoVendedorUtilsPortalVendedorApiModule } from '../../portal-vendedor-api';

@NgModule({
  imports: [
    CommonModule,
    PortalDoVendedorUtilsBaseApiModule,
    PortalDoVendedorUtilsPortalVendedorApiModule,
    MatDialogModule,
  ],
})
export class PortalDoVendedorUtilsPortalDoVendedorNewApiModule {}
